/**
 * ProjectUserRole_TransitionsEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
import { BugTransitionEntity } from "../BugTransitionEntity";
import { ProjectUserRole_TransitionsEntity } from "../ProjectUserRole_TransitionsEntity";
declare global {
    interface EntityTypeMap {
        ProjectUserRole_Transitions: ProjectUserRole_TransitionsEntity;
    }
}
export abstract class ProjectUserRole_TransitionsGeneratedEntity extends BaseEntity {
    public abstract relationId: string;
    public abstract templateId: string | null;
    public abstract role: ProjectUserRoleEntity;
    public abstract transition: BugTransitionEntity;
}
